import React, { useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function Completed() {
  const search = useSelector((state: RootState) => state.searching.patientData);
  const [payment, setpayment] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    baseUrl
      .get("payment/getCompletedPayment", { headers: { keyword: search } })
      .then((response) => setpayment(response.data.data))
      .catch((error) => console.log(error));
  }, [search]);

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
          <CheckCircleIcon className="text-primary" sx={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="text-sm font-bold text-slate-800">Completed Payments</h3>
          <p className="text-xs text-slate-500">{payment.length} records</p>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-slate-100">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Invoice</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Patient</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Total</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Discount</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Paid</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Status</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {payment.map((item: any, index) => (
              <tr
                key={index}
                onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
                className="hover:bg-slate-50 cursor-pointer transition-colors"
              >
                <td className="px-3 py-2 text-xs font-medium text-indigo-600">{item?.invoiceNo}</td>
                <td className="px-3 py-2 text-xs font-medium text-slate-800">{item?.patientData?.fullName}</td>
                <td className="px-3 py-2 text-xs text-slate-600">{item?.total}</td>
                <td className="px-3 py-2 text-xs text-orange-600">{item?.discount}</td>
                <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.card + item?.cash}</td>
                <td className="px-3 py-2">
                  <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-md text-xs font-semibold flex items-center gap-1 w-fit">
                    <CheckCircleIcon sx={{ fontSize: 12 }} /> Paid
                  </span>
                </td>
                <td className="px-3 py-2 text-xs text-slate-500">{item?.patientData?.updatedAt?.split("T")[0]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {payment.map((item: any, index) => (
          <div
            key={index}
            onClick={() => navigate(`/client/payments/invoice/${item?._id}`)}
            className="bg-white rounded-lg shadow-sm border border-slate-100 p-3 cursor-pointer"
          >
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-medium text-xs text-indigo-600">{item?.invoiceNo}</span>
              <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-md text-xs font-semibold">Paid</span>
            </div>
            <h3 className="font-semibold text-xs text-slate-800">{item?.patientData?.fullName}</h3>
            <div className="flex items-center justify-between mt-1.5 text-xs">
              <span className="text-slate-500">Total: {item?.total}</span>
              <span className="font-semibold text-emerald-600">{item?.card + item?.cash}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Completed;
